export const FETCH_SEARCH_RESULTS_REQUEST = 'search/FETCH_SEARCH_RESULTS_REQUEST';
export const FETCH_SEARCH_RESULTS_SUCCESS = 'search/FETCH_SEARCH_RESULTS_SUCCESS';
export const FETCH_SEARCH_RESULTS_FAILURE = 'search/FETCH_SEARCH_RESULTS_FAILURE';

export const UPDATE_FIELD = 'search/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'search/SET_DEFAULT_DATA';